
export const VERSION = '5.4.6'; // Update this manually on each release

